import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowLeftIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6304 5.1143C12.021 5.50483 12.021 6.13799 11.6304 6.52852L6.33755 11.8214L21.9233 11.8214C22.4756 11.8214 22.9233 12.2691 22.9233 12.8214C22.9233 13.3737 22.4756 13.8214 21.9233 13.8214H6.33755L11.6304 19.1143C12.021 19.5048 12.021 20.138 11.6304 20.5285C11.2399 20.919 10.6068 20.919 10.2162 20.5285L3.21623 13.5285C2.82571 13.138 2.82571 12.5048 3.21623 12.1143L10.2162 5.1143C10.6068 4.72378 11.2399 4.72378 11.6304 5.1143Z"
            />
        </SvgIcon>
    );
};

export default ArrowLeftIcon;
